import { Title, Text, Card } from '@tremor/react';

export function MembersPage(): JSX.Element {
  return (
    <div>
      <Title>Members</Title>
      <Card className="mt-4">
        <Text>
          Member directory + per-member context lands in Phase 5.5 once the Phase 6 AI
          context-builder needs it. For now, member detail is reachable from individual
          response rows.
        </Text>
      </Card>
    </div>
  );
}
